import { useMediaQuery } from '@material-ui/core'
import React from 'react'
import styled, { useTheme } from 'styled-components'
import { Accordion } from '../../../components/accordion/accordion'
import { html } from '../../../utils/htmlParser'
import { trackFaqView } from '../../../utils/trackFaqView'

export const StyledAccordionPanel = styled(Accordion)`
  background: #fff;
  border-radius: 5px;
  padding: 0;

  ${props => props.theme.breakpoints.up('sm')} {
    margin-right: 0;
  }

  &.Mui-expanded {
    margin-right: 0;
  }
`
export const StyledAccordionTitle = styled(Accordion)`
  color: ${props => props.theme.palette.text.secondary};
  font-size: ${props => props.theme.typography.pxToRem(16)};

  .Mui-expanded {
    color: ${props => props.theme.palette.text.primary};
  }

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(22)};
  }

`
export const StyledAccordionContent = styled(Accordion)`
  color: ${props => props.theme.palette.text.secondary};
  font-size: ${props => props.theme.typography.pxToRem(14)};
  line-height: 1.8;

  ${props => props.theme.breakpoints.up('sm')} {
    font-size: ${props => props.theme.typography.pxToRem(17)};
  }
`
export const StyledAccordionColumn = styled(Accordion)`
  padding-right: 0;

  ${props => props.theme.breakpoints.up('sm')} {
    padding: 0 ${props => props.theme.typography.pxToRem(10)};
  }
`

export type PopularQuestionItem = {
  id?: string | null
  title?: string | null
  faqText?: string | null
}

export type PopularQuestionsProps = {
  faqs?: PopularQuestionItem[]
}

const renderColumn = (faqs: PopularQuestionItem[]) => (
  <StyledAccordionColumn column>
    {faqs.map((faq) => (
      <StyledAccordionPanel panel key={faq.id} tabIndex={0} onExpand={() => trackFaqView(faq.id)}>
        <StyledAccordionTitle title>{faq.title}</StyledAccordionTitle>
        {faq.faqText && (
          <StyledAccordionContent content>{html(faq.faqText)}</StyledAccordionContent>
        )}
      </StyledAccordionPanel>
    ))}
  </StyledAccordionColumn>
)

export const PopularQuestions: React.VFC<PopularQuestionsProps> = ({ faqs }) => {
  const theme = useTheme()
  const isMobile = useMediaQuery(theme.breakpoints.down('xs'))

  if (!faqs?.length) {
    return null
  }

  // Split the ranked list into two columns, keeping rank order top-to-bottom
  // (most popular first in the left column, remainder in the right).
  const splitIndex = Math.ceil(faqs.length / 2)
  const leftColumnFaqs = faqs.slice(0, splitIndex)
  const rightColumnFaqs = faqs.slice(splitIndex)

  return (
    <Accordion spacing={isMobile ? 0 : 2}>
      {renderColumn(leftColumnFaqs)}
      {rightColumnFaqs.length > 0 && renderColumn(rightColumnFaqs)}
    </Accordion>
  )
}